export default function Footer() {
  return (
    <footer style={{
      background: "#1C1C1C",
      color: "#F9E4B7",
      textAlign: "center",
      padding: "20px",
      marginTop: "40px"
    }}>
      <p>© 2025 SmashKaro Badminton | Train Hard. Smash Harder.</p>
    </footer>
  );
}
